import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { unserialize } from 'php-serialize';
import React, { Component, lazy } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import CONSTANTS from '../../constants';
import TimeHelper from '../../helpers/TimeHelper';
import '../../react-datepicker.css';
import CartService from '../../services/CartService';
import LocationService from '../../services/LocationService';
const DatePicker = lazy(() => import('react-datepicker'));
class TimePickerModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      orderDate: this.props.order_date,
      selectedDate: this.props.order_date === CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY ? moment().format('YYYY-MM-DD') : moment().add(1, 'days').format('YYYY-MM-DD'),
      isTimeChanged: false,
      serverTime: '',
      asapSelected: false,
      isNowEnabled: false
    };
    this.datePickerRef = React.createRef();
  }

  async componentDidMount() {
    let timeData = await LocationService.fetchServerTime();
    let currentTime = TimeHelper.convertServerTimeToUserTime(timeData.serverTime);
    this.setState({ serverTime: currentTime });
    const isNowEnabled = await TimeHelper.isNowEnabled(this.props?.location || '', this.props?.order_type_id);
    this.setState({ isNowEnabled });
  }

  handleASAPSelection = async () => {
    this.setState({ asapSelected: true });
    let timeData = await LocationService.fetchServerTime();
    let currentTime = TimeHelper.convertServerTimeToUserTime(timeData.serverTime);
    this.changeDate(this.state.orderDate, new Date(currentTime), true, 1);
    this.props.toggleModal();
  };

  async onTimeChange(date) {
    // this.props.onChange({ target: { name: 'order_time', value: new Date(date) } });
    // this.props.onChange({ target: { name: 'isPickUpNow', value: 2 } });    
    this.changeDate(this.state.orderDate, new Date(date), true);
    this.props.toggleModal();
  }

  onDateChange(value) {
    let selectedDate = '';
    let currentDate = moment().format('YYYY-MM-DD');
    if (value === CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY) {
      selectedDate = moment().format('YYYY-MM-DD')
    } else if (value === CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW) {
      selectedDate = moment(currentDate).add(1, 'days').format('YYYY-MM-DD');
    } else {
      selectedDate = value;
    }
    this.setState({ orderDate: value, selectedDate });
  }




  async closeTimePickModal() {
    //   await this.changeDate(this.state.orderDate, TimeHelper.getDateFromTimeOption(this.state.orderDate, this.props.order_time), true);
    this.props.toggleModal();
  }

  changeDate(orderDate, orderTime, suppressErrors = false, isASAP = 0) {
    if (this.props.location.is_adv_ordering === 1) {
      let currentDate = moment().format('YYYY-MM-DD');
      let selectedDate = '';
      if (orderDate === CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY) {
        selectedDate = moment().format('YYYY-MM-DD');
        orderTime = moment(orderTime).set({
          year: moment(selectedDate).year(),
          month: moment(selectedDate).month(),
          date: moment(selectedDate).date()
        }).toDate();
      } else if (orderDate === CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW) {
        selectedDate = moment(currentDate).add(1, 'days').format('YYYY-MM-DD');
        orderTime = moment(orderTime).set({
          year: moment(selectedDate).year(),
          month: moment(selectedDate).month(),
          date: moment(selectedDate).date()
        }).toDate();
      } else {
        selectedDate = orderDate; // Custom order date handling
        orderTime = moment(orderTime).set({
          year: moment(selectedDate).year(),
          month: moment(selectedDate).month(),
          date: moment(selectedDate).date()
        }).toDate();
      }
      const orderData = CartService.getOrderData(
        this.props.location.orderTypes,
        this.props.location
      );


      if (currentDate !== selectedDate) {
        let tomorrow = moment(currentDate).add(1, 'days').format('YYYY-MM-DD');
        if (tomorrow === selectedDate) {
          orderData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW;
          orderData.order_time = orderTime;
          orderData.isPickUpNow = 2;
        } else {
          // Set custom order date only if it's not already set
          if (orderData.order_date !== selectedDate) {
            orderData.order_date = selectedDate; // Set custom order date
          }
          orderData.isPickUpNow = 2;
          orderData.order_time = orderTime;
        }
      } else if (currentDate === selectedDate) {
        orderData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
        orderData.isPickUpNow = TimeHelper.differenceFromNow(orderTime) < 60 ? 1 : 2;
        orderData.order_time = orderTime;
      } else {
        let current = moment();
        let momentOrderTime = moment(orderTime);
        if (momentOrderTime.unix() > current.unix()) {
          orderData.isPickUpNow = 2;
          orderData.order_time = orderTime;
        }
      }

      localStorage.setItem('is_custom_time', 1);
      localStorage.setItem('is_asap', isASAP);
      CartService.setOrderData(orderData, this.props.location.orderTypes, this.props.location);
    }
    this.props.onChange({ target: { suppressErrors, name: 'order_date', value: orderDate } });
    this.props.onChange({ target: { suppressErrors, name: 'order_time', value: orderTime } });
    this.props.onChange({ target: { suppressErrors, name: 'isPickUpNow', value: 2 } });
  }


  onNowSelect(value) {
    this.changeDate(value, new Date());
    //this.toggleTimeComponent();
  }

  getHeight = () => {
    const deviceHeight = window.innerHeight; // Get the current window height
    console.log(deviceHeight);
    // Optionally adjust the height based on screen size (you can tweak this logic)
    let adjustedHeight = deviceHeight * 0.3;
    if (deviceHeight <= 700) {
      adjustedHeight = deviceHeight * 0.3;  // For small screens
    } else if (deviceHeight > 700 && deviceHeight <= 750) {
      adjustedHeight = deviceHeight * 0.35;  // For medium screens
    }
    else if (deviceHeight <= 900) {
      adjustedHeight = deviceHeight * 0.4;  // For medium screens
    } else if (deviceHeight <= 950) {
      adjustedHeight = deviceHeight * 0.5;  // For medium screens
    } else if (deviceHeight <= 1024) {
      adjustedHeight = deviceHeight * 0.65;  // For medium screens
    } else if (deviceHeight <= 1180) {
      adjustedHeight = deviceHeight * 0.65;  // For medium screens
    } else {
      adjustedHeight = deviceHeight * 0.5;  // For large screens
    }
    return adjustedHeight;
  };


  render() {
    let location = this.props.location ? this.props.location : '';
    let todayOption = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
    let tomorrowOption = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TOMORROW;
    let advDates = TimeHelper.getAdvDates(location.adv_ordering_days);
    let options = location ? unserialize(location.options) : [];
    let events = options && options.opening_hours ? options.opening_hours.events : [];
    let event_holidays =
      options && options.opening_hours ? options.opening_hours.event_holidays : [];

    let incTimes = location ? TimeHelper.getEnabledTimesFor(this.props.order_type_id, this.state.serverTime, {
      advDaysCount: location.adv_ordering_days,
      orderTypes: this.props.orderTypes,
      workingHours: this.props.workingHours,
      currentTime: moment(this.props.current_time),
      order_lead_time: location.order_lead_time,
      order_max_time: location.order_max_time,
      locOptions: options,
      events: events,
      eventWorkingHours: this.props.eventWorkingHours,
      event_holidays: event_holidays
    })
      : [];


    // Check if selectedDate exists in incTimes and has values
    const selectedTimes = incTimes[this.state.selectedDate];
    let height = 0;
    height = this.getHeight(incTimes);

    if (Array.isArray(selectedTimes) && selectedTimes.length > 0) {

      // If there are valid time slots, assign them to incTimes
      incTimes = selectedTimes;


    } else {
      // If no valid time slots, set incTimes to an empty array
      incTimes = [];
    }
    let grid_layout = localStorage.getItem('grid_layout');
    const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';
    if (grid_layout === 'old') {
      return (
        <StyledModal
          className={`modal sub-modal-t new-time-modal`}
          isOpen={this.props.showModal}
          toggle={this.props.toggleModal}
        >
          <div className="modal-header no-border primary-color">
            <h5 className="text-bold modal-title primary-font-color">Choose your {this.props.isDelivery ? 'delivery' : 'pickup'}  date and time</h5>
            {grid_layout !== 'old' ? (
              <div className='primary-color' onClick={this.props.toggleModal} style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faTimes} color='var(--primary-font-color)' />
              </div>
            ) : (
              <div className='primary-color' onClick={this.props.toggleModal}>
                <FontAwesomeIcon icon={faTimes} color='var(--primary-font-color)' />
              </div>
            )}
          </div>
          <ModalBody className="primary-color">
            <div className="time-component">
              <div className="date-options">
                <div className="card flex-md-row box-shadow h-md-250 p-3 no-border primary-color">
                  <div className={`row ${advDates.length >= 3 ? 'row-width' : ''}`}>
                    <div className="col-lg-12 order-types">
                      <div className="radio-container">
                        <div className={`radio-tile-group  ${location.adv_ordering_days >= 3 ? 'dates-horizontal' : 'justify-content-center'}`}>

                          {advDates.length === 1 &&
                            <>
                              <div className={`input-container input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`} >
                                <input checked={this.state.orderDate === todayOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, todayOption)} />
                                <div className='radio-tile modal-radio-tile' >
                                  <label className='radio-tile-label' > {todayOption}</label>
                                </div>
                              </div>
                            </>
                          }

                          {advDates.length < 3 && advDates.length > 1 &&
                            <>
                              <div className={`input-container input-container-modal order-type highlight-color-active `}>
                                <input checked={this.state.orderDate === todayOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, todayOption)} />
                                <div className='radio-tile modal-radio-tile' >
                                  <label className='radio-tile-label' > {todayOption}</label>
                                </div>
                              </div>
                              <div className={`input-container input-container-modal order-type highlight-color-active `}>
                                <input checked={this.state.orderDate === tomorrowOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, tomorrowOption)} />
                                <div className='radio-tile modal-radio-tile' >
                                  <label className='radio-tile-label' >{tomorrowOption}</label>
                                </div>
                              </div>
                            </>
                          }
                          {advDates && advDates.length > 3 && advDates.map((date, index) => {
                            if (index > this.props.days - 1) {
                              if (index === 0) {
                                return (
                                  <div className={`input-container input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`}>
                                    <input checked={this.state.orderDate === todayOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, todayOption)} />
                                    <div className='radio-tile modal-radio-tile' >
                                      <label className='radio-tile-label' > {todayOption}</label>
                                    </div>
                                  </div>
                                )
                              } else if (index === 1) {
                                return (
                                  <div className={`input-container input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`}>
                                    <input checked={this.state.orderDate === tomorrowOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, tomorrowOption)} />
                                    <div className='radio-tile modal-radio-tile' >
                                      <label className='radio-tile-label' >{tomorrowOption}</label>
                                    </div>
                                  </div>
                                )
                              } else {
                                return (
                                  <div className={`input-container input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`}>
                                    <input checked={this.state.orderDate === TimeHelper.getDateString(date) ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, TimeHelper.getDateString(date))} />
                                    <div className='radio-tile modal-radio-tile' >
                                      <label className='radio-tile-label' >{TimeHelper.getDateStringFormat(date)}</label>
                                    </div>
                                  </div>
                                )
                              }
                            }
                            return '';
                          })
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="time-picker">

                {incTimes.length > 0 && (
                  <DatePicker
                    className="form-control"
                    selected={this.props.order_time}
                    onChange={this.onTimeChange.bind(this)}
                    // minTime={includedTimes[0]}
                    // maxTime={includedTimes[includedTimes.length-1]}
                    includeTimes={incTimes}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    dateFormat="h:mm aa"
                    popperPlacement="top-center"
                    inline
                  />
                )}
                {incTimes.length === 0 && (
                  <div
                    class="d-flex align-items-center justify-content-center"
                    style={{ height: '10vh' }}
                  >
                    <h5 className="text-bold">No time options left for orders on this day.</h5>
                  </div>
                )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="no-border primay-color">
            <div className="container-fluid">
              <div className="row">
                <Button
                  className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                  onClick={this.props.toggleModal}
                >
                  Continue
                </Button>
              </div>
            </div>
          </ModalFooter>
        </StyledModal >
      );
    } else if (grid_layout !== 'old') {
      return (
        <StyledModal
          className={`modal sub-modal-t new-time-modal`}
          isOpen={this.props.showModal}
          toggle={this.props.toggleModal}
        >
          <div className="modal-header no-border primary-color">
            <h5 className="text-bold modal-title primary-font-color">Choose your {this.props.isDelivery ? 'delivery' : 'pickup'} date and time</h5>
            <div
              className={`close-icon primary-color ${card_outline}`}
              onClick={this.props.toggleModal}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTimes} color='var(--primary-font-color)' />
            </div>
          </div>
          <ModalBody className="primary-color">
            <div className="time-component">
              <div className="date-options">
                <div className="card flex-md-row box-shadow h-md-250 p-3 no-border primary-color">
                  <div className={`row ${advDates.length >= 3 ? 'row-width' : ''}`}>
                    <div className="col-lg-12 order-types">
                      <div className="radio-container">
                        {/* <div className="radio-tile-group justify-content-center">
                          <div className="input-container input-container-modal order-type">
                            <input
                              checked={this.props.order_date === todayOption ? true : false}
                              className="radio-button"
                              type="radio"
                              onChange={this.onDateChange.bind(this, todayOption)}
                            />
                            <div className="radio-tile modal-radio-tile">
                              <label className="radio-tile-label"> {todayOption}</label>
                            </div>
                          </div>
                          <div className="input-container input-container-modal order-type">
                            <input
                              checked={this.props.order_date === tomorrowOption ? true : false}
                              className="radio-button"
                              type="radio"
                              onChange={this.onDateChange.bind(this, tomorrowOption)}
                            />
                            <div className="radio-tile modal-radio-tile">
                              <label className="radio-tile-label">{tomorrowOption}</label>
                            </div>
                          </div>
                        </div> */}
                        <div className={`radio-tile-group  ${location.adv_ordering_days >= 3 ? 'dates-horizontal' : 'justify-content-center'}`}>

                          {advDates.length === 1 &&
                            <>
                              <div className={`input-container input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`} >
                                <input checked={this.state.orderDate === todayOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, todayOption)} />
                                <div className='radio-tile modal-radio-tile' >
                                  <label className='radio-tile-label' > {todayOption}</label>
                                </div>
                              </div>
                            </>
                          }
                          {advDates.length < 3 && advDates.length > 1 &&
                            <>
                              <div className={`input-container input-container-modal order-type highlight-color-active `}>
                                <input checked={this.state.orderDate === todayOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, todayOption)} />
                                <div className='radio-tile modal-radio-tile' >
                                  <label className='radio-tile-label' > {todayOption}</label>
                                </div>
                              </div>
                              <div className={`input-container input-container-modal order-type highlight-color-active `}>
                                <input checked={this.state.orderDate === tomorrowOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, tomorrowOption)} />
                                <div className='radio-tile modal-radio-tile' >
                                  <label className='radio-tile-label' >{tomorrowOption}</label>
                                </div>
                              </div>
                            </>
                          }
                          {advDates && advDates.length >= 3 && advDates.map((date, index) => {

                            if (index === 0) {
                              return (
                                <div className={`input-container input-container-scroll  input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`}>
                                  <input checked={this.state.orderDate === todayOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, todayOption)} />
                                  <div className='radio-tile modal-radio-tile' >
                                    <label className='radio-tile-label' > {todayOption}</label>
                                  </div>
                                </div>
                              )
                            } else if (index === 1) {
                              return (
                                <div className={`input-container input-container-scroll  input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`}>
                                  <input checked={this.state.orderDate === tomorrowOption ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, tomorrowOption)} />
                                  <div className='radio-tile modal-radio-tile' >
                                    <label className='radio-tile-label' >{tomorrowOption}</label>
                                  </div>
                                </div>
                              )
                            } else {
                              return (
                                <div className={`input-container input-container-scroll  input-container-modal order-type highlight-color-active ${location.adv_ordering_days !== 0 ? 'dates-horizontal-flex' : ''}`}>
                                  <input checked={this.state.orderDate === TimeHelper.getDateString(date) ? true : false} className='radio-button' type='radio' onChange={this.onDateChange.bind(this, TimeHelper.getDateString(date))} />
                                  <div className='radio-tile modal-radio-tile' >
                                    <label className='radio-tile-label' >{TimeHelper.getDateStringFormat(date)}</label>
                                  </div>
                                </div>
                              )
                            }

                          })
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="time-picker">
                <div
                  ref={this.datePickerRef}
                  style={{ height: `${height}px`, overflowY: 'auto' }} // Set height dynamically with scroll
                >
                  {this.state.orderDate === todayOption && this.state?.isNowEnabled ?
                    <div className="custom-datepicker-container mt-1">
                      <div
                        className={`asap-option ${this.state.asapSelected ? 'selected' : ''}`}
                        onClick={this.handleASAPSelection.bind(this)}
                      >
                        ASAP
                      </div>
                    </div> : ''}
                  {incTimes.length > 0 && (
                    <DatePicker
                      className="form-control"
                      onChange={this.onTimeChange.bind(this)}
                      // minTime={includedTimes[0]}
                      // maxTime={includedTimes[includedTimes.length-1]}
                      includeTimes={incTimes}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      dateFormat="h:mm aa"
                      popperPlacement="top-center"
                      inline
                    />
                  )}
                  {incTimes.length === 0 && (
                    <div
                      class="d-flex align-items-center justify-content-center"
                      style={{ height: '10vh' }}
                    >
                      <h5 className="text-bold">No time options left for orders on this day.</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="no-border primary-color">
            <div className="container-fluid">
              <div className="row">
                <Button
                  className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                  onClick={this.closeTimePickModal.bind(this)}
                >
                  Continue
                </Button>
              </div>
            </div>
          </ModalFooter>
        </StyledModal>
      );
    }
  }
}

const StyledModal = styled(Modal)`
  .modal-header {
    padding: 35px 30px 0px 30px !important;
    .modal-title {
      font-size: 16px;
      font-weight: 400 !important;
      line-height: 22px;
      margin: 0;
    }

    .close-icon {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border: 1px solid rgba(209, 209, 209, 0.5);
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .modal-body {
    padding: 15px 30px !important;
    .time-component {
      // display: flex;
      // justify-content: space-between;

      .order-types {
        .radio-container {
          .radio-tile-group {
            justify-content: flex-start !important;
            .input-container {
              width: 200px !important;
              overflow: hidden;
              border-radius: 6px !important;
              //margin: 0;

              &:nth-of-type(1) {
                margin-bottom: 15px;
              }
            }

            .input-container-single {
              width: 100% !important;
              overflow: hidden;
              border-radius: 6px !important;
              //margin: 0;

              &:nth-of-type(1) {
                margin-bottom: 15px;
              }
            }
            .input-container-scroll {
              width: 150px !important;
            }
          }
        }
      }

      .card {
        padding: 0px !important;
      }

      .time-picker {
        .react-datepicker__time-container
          .react-datepicker__time
          .react-datepicker__time-box
          ul.react-datepicker__time-list
          li.react-datepicker__time-list-item--selected {
          border-radius: 6px !important;
        }
        .react-datepicker__time-container
          .react-datepicker__time
          .react-datepicker__time-box
          ul.react-datepicker__time-list
          li.react-datepicker__time-list-item:hover {
          border-radius: 6px !important;
        }
      }

      @media (max-width: 375px) {
        flex-direction: column;
        row-gap: 15px;
        .order-types {
          .radio-container {
            .radio-tile-group {
              .input-container {
                width: 100% !important;
              }
            }
          }
        }
      }
    }
  }
`;
export default TimePickerModal;